<template lang="pug">
    div
        v-toolbar(card='' dark='' :color='colors.infoSub' height="40")
            v-toolbar-title.white--text ARQUEO GENERADO
        v-card
            v-list()
                v-subheader()
                    | GENERAL
                v-list-group( )
                    v-list-tile(slot='activator')
                        v-list-tile-content
                            v-list-tile-title() 
                                v-layout
                                    v-flex(md10) 
                                        v-icon.mr-2 subdirectory_arrow_right
                                        |INGRESO PAGO CLIENTES
                                    v-flex(md2) {{totalCustomerSummaries | mixFormatCurrency}}
                    v-list(v-for='(payment,key) in setDetailCustomerSummaries' :key='key' @click='')
                        v-list-tile()
                            v-list-tile-content
                                v-list-tile-title() 
                                    v-layout
                                        v-flex(md1) 
                                            v-icon {{customer[key].icon}}
                                        v-flex(md9) {{ customer[key].paymentType}}
                                        v-flex(md2 color="indigo") {{payment | mixFormatCurrency}}
                //- v-list-group( )
                //-     v-list-tile(slot='activator')
                //-         v-list-tile-content
                //-             v-list-tile-title() 
                //-                 v-layout
                //-                     v-flex(md10) 
                //-                         v-icon.mr-2 subdirectory_arrow_right
                //-                         |INGRESO PAGO EMPLEADOS
                //-                     v-flex(md2) {{totalEmployeeSummaries | mixFormatCurrency}}
                //-     v-list(v-for='(payment,key) in setDetailEmployeeSummaries' :key='key' @click='')
                //-         v-list-tile()
                //-             v-list-tile-content
                //-                 v-list-tile-title() 
                //-                     v-layout
                //-                         v-flex(md1) 
                //-                             //v-icon {{employee[key].icon}}
                //-                         //v-flex(md9) {{ employee[key].paymentType}}
                //-                         v-flex(md2 color="indigo") {{payment | mixFormatCurrency}}
                
                //- v-list-group( )
                //-     v-list-tile(slot='activator')
                //-         v-list-tile-content
                //-             v-list-tile-title() 
                //-                 v-layout
                //-                     v-flex(md10) 
                //-                         v-icon.mr-2 subdirectory_arrow_left
                //-                         |EGRESOS
                //-                     v-flex(md2) {{setDetailEgressSummaries.egressCashMovementTotal | mixFormatCurrency}}
                //-     v-list(v-for='(payment,key) in setDetailEgressSummaries' :key='key' @click='')
                //-         v-list-tile()
                //-             v-list-tile-content
                //-                 v-list-tile-title() 
                //-                     v-layout
                //-                         v-flex
                //-                             |{{key}}
                //-                         v-flex(md1) 
                //-                             v-icon {{egress[key].icon}}
                                        //- v-flex(md9) {{ egress[key].paymentType}}
                                        //- v-flex(md2 color="indigo") {{payment | mixFormatCurrency}}
            //- v-card-text
            //-     p.headline.text-md-right TOTAL : $ 300.0000
               
</template>

<script>
import {mapState} from 'vuex'
import CurrencyUtils from '@/mixins/CurrencyUtils'
export default {
    name: 'detail-summaries',
    props: {},
    data: function(){
        return {
            customer:{
                customerSaleWithCashTotal:{icon:'attach_money',paymentType:'EFECTIVO'},
                customerSaleWithCheckTotal:{icon:'chrome_reader_mode',paymentType:'CHEQUE'},
                customerSaleWithCreditCashTotal:{icon:'credit_card',paymentType:'TARJETA CREDITO'},
                //customerSaleWithCustomerCreditTotal:{icon:'credit_card',paymentType:'TARJETA DEBITO'}, //
                customerSaleWithDebitCardTotal: {icon:'credit_card',paymentType:'TARJETA DEBITO'},
            },
            employee:{
                employeeSaleWithCashTotal:{icon:'attach_money',paymentType:'EFECTIVO'},
                employeeSaleWithCheckTotal:{icon:'chrome_reader_mode',paymentType:'CHEQUE'},
                employeeSaleWithCreditCashTotal:{icon:'credit_card',paymentType:'TARJETA CREDITO'},
                //employeeSaleWithEmployeeCreditTotal:{icon:'credit_card',paymentType:'TARJETA DEBITO'}, //
                employeeSaleWithDebitCardTotal: {icon:'credit_card',paymentType:'TARJETA DEBITO'},
            },
            egress:{
                egressCashMovementTotal:{icon:'subdirectory_arrow_right',paymentType:'EGRESOS'},
            },
        }
    },
    computed: {
        ...mapState('PaymentSummariesModule',{
            setDetailCustomerSummaries:'setDetailCustomerSummaries',
            setDetailEmployeeSummaries: 'setDetailEmployeeSummaries',
            setDetailEgressSummaries: 'setDetailEgressSummaries',
            totalCustomerSummaries : 'totalCustomerSummaries',
            totalEmployeeSummaries :'totalEmployeeSummaries'
        }),
    },
    methods: {
        icon: function(key){
            switch (key) {
                case 'customerSaleWithCashTotal':
                    return 'attach_money'
                    break;
            
                default:
                    return 'attach_money'
                    break;
            }
        }
    },
    watch: {},
    components: {},
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function(){
        //console.log(this.customer)
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    // .v-list__group__header__append-icon{
    //     display:none;
    // }
</style>